import React, { FC } from 'react';

interface ButtonProps {
	onClick?: (event: any) => void;
	disabled?: boolean;
	isLoading?: boolean;
	className?: string;
	title: string;
}

export const Button: FC<ButtonProps> = ({ onClick, disabled, className = '', isLoading, title }) => {
	return (
		<button
			onClick={onClick}
			className={`flex items-center justify-center rounded-md border border-transparent ${className} px-6 py-3 text-base font-medium  shadow-sm  disabled:opacity-50`}
			disabled={disabled}
		>
			{isLoading && (
				<div className="flex relative mr-3">
					<div className="absolute top-1/2 transform -translate-x-full -translate-y-1/2">
						<div className="border-4 border-solid border-opacity-10 border-blue-500 border-left-4 rounded-full w-[15px] h-[15px] small-spinner"></div>
					</div>
				</div>
			)}
			{title}
		</button>
	);
};
